import ApprovalHolidayworkApplicationPage from './ApprovalHolidayworkApplicationPage'

export default ApprovalHolidayworkApplicationPage